














































































































































import * as _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Node from '@/inode';
import { IPlan } from '../iplan';
import { NodeProp } from '../enums';
import { duration, durationClass, percent } from '@/filters';
import { SortedTable, SortLink } from 'vue-sorted-table';

@Component({
  filters: {
    duration,
    durationClass,
    percent,
  },
  components: {
    SortedTable,
    SortLink,
  },
})
export default class Stats extends Vue {
  @Prop() private plan!: IPlan;

  private nodes = [] as Node[];

  private lodash = _;
  private nodeProps = NodeProp;
  private executionTime: number = 0;

  private created(): void {
    this.executionTime = this.plan.planStats.executionTime || this.plan.content.Plan[NodeProp.ACTUAL_TOTAL_TIME];
    const root = this.plan.content.Plan;
    this.flatten(this.nodes, root);
    _.each(this.plan.ctes, (cte) => {
      this.flatten(this.nodes, cte);
    });
  }

  private flatten(output: Node[], node: any) {
    // [level, node, isLastSibbling, branches]
    output.push(node);
    _.each(node.Plans, (subnode) => {
      this.flatten(
        output,
        subnode,
      );
    });
  }

  private durationPercent(nodes: Node[]) {
    return _.sumBy(nodes, NodeProp.EXCLUSIVE_DURATION) / this.executionTime;
  }

  private get perTable() {
    const tables: {[key: string]: Node[]} = _.groupBy(
      _.filter(this.nodes, (n) => n[NodeProp.RELATION_NAME] !== undefined),
      NodeProp.RELATION_NAME,
    );
    const values: any[] = [];
    _.each(tables, (nodes, tableName) => {
      values.push({
        name: tableName,
        count: nodes.length,
        time: _.sumBy(nodes, NodeProp.EXCLUSIVE_DURATION),
        timePercent: this.durationPercent(nodes),
        nodes,
      });
    });
    return values;
  }

  private get perNodeType() {
    const nodeTypes: {[key: string]: Node[]} = _.groupBy(this.nodes, NodeProp.NODE_TYPE);
    const values: any[] = [];
    _.each(nodeTypes, (nodes, nodeType) => {
      values.push({
        name: nodeType,
        count: nodes.length,
        time: _.sumBy(nodes, NodeProp.EXCLUSIVE_DURATION),
        timePercent: this.durationPercent(nodes),
      });
    });
    return values;
  }

  private get perIndex() {
    const indexes: {[key: string]: Node[]} = _.groupBy(
      _.filter(this.nodes, (n) => n[NodeProp.INDEX_NAME] !== undefined),
      NodeProp.INDEX_NAME,
    );
    const values: any[] = [];
    _.each(indexes, (nodes, indexName) => {
      values.push({
        name: indexName,
        count: nodes.length,
        time: _.sumBy(nodes, NodeProp.EXCLUSIVE_DURATION),
        timePercent: this.durationPercent(nodes),
      });
    });
    return values;
  }
}
